"use strict";function reverse($sce){return function(items){return items.slice().reverse()}}angular.module("app").filter("reverse",reverse);